import api from "@/api";

const state = {
  employees: []
};

// getters
const getters = {};

// mutations
const mutations = {
  setEmployees(state, data) {
    state.employees = data;
  }
};

// actions
const actions = {
  getAllEmployees({ commit }) {
    return new Promise((resolve, reject) => {
      api
        .get("users", {
          params: { limit: 100, sort: "email" }
        })
        .then(res => {
          let employeesData = res.data;
          console.log("res.data", res.data, "employeesData", employeesData);
          commit("setEmployees", employeesData);
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
